export let BASE_URL = 'https://api.almaalee.com/'
// export let BASE_URL = 'https://qrcode-ctqi.onrender.com/'
//export let BASE_URL = 'http://localhost:8080/'
